import { useCallback } from 'react';
import { ClosestChallenge } from '../../../../../interfaces/ClosestChallenge';
import { goTo } from '../../../../../../shared/utils/angularUtils';
import { openNewTab } from '../../../../../../shared/utils/windowUtils/openNewTab/openNewTab';
import { challengeGuideLink } from '../../../../../../guides-and-additional-info/constants/externalLinks';

export const useChallengeBannerContent = (closestChallenge: ClosestChallenge | null) => {
  const challengeId = closestChallenge?.id ?? null;

  const title = closestChallenge?.challengeName ?? 'NO ACTIVE CHALLENGES YET';
  const description =
    closestChallenge?.description ??
    'Create a challenge, invite participants, and track their progress.';

  const primaryActionLabel = challengeId
    ? 'Open Challenge Preview'
    : 'Create a Challenge';
  const secondaryActionLabel = challengeId
    ? 'Open Challenge Settings'
    : 'Open Challenge Guide';

  const onPrimaryAction = useCallback(() => {
    if (challengeId) {
      goTo(`/challenge-landing/${challengeId}`);
    } else {
      goTo('/challenge-create');
    }
  }, [challengeId]);

  const onSecondaryAction = useCallback(() => {
    if (challengeId) {
      goTo(`/challenge-profile/${challengeId}`);
    } else {
      openNewTab(challengeGuideLink);
    }
  }, [challengeId]);

  return {
    title,
    description,
    primaryActionLabel,
    secondaryActionLabel,
    onPrimaryAction,
    onSecondaryAction,
  };
};
